import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'virtual:routr-tokens.css';
import './styles/fonts.css';
import './styles/app.css';
import './styles/web.css';
import { addSprite } from './ui/Icon';
import { Root } from './app/Root';
import { ui } from './app/ui';

document.documentElement.dataset.theme = ui.get().theme;
addSprite();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
